import { useEffect } from 'react';
import { startAppcues } from 'data/usecases/start-appcues';
import { useLocation } from 'react-router-dom';

let lastLocationPath: string | undefined;

export const useAppcues = () => {
    const location = useLocation();
    useEffect(() => {
        if (lastLocationPath !== location.pathname) {
            startAppcues();
            lastLocationPath = location.pathname;
        }
    }, [location]);
};
